/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceType,
    DeviceTypeFromJSON,
    DeviceTypeFromJSONTyped,
    DeviceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface HostDevice
 */
export interface HostDevice {
    /**
     * 
     * @type {number}
     * @memberof HostDevice
     */
    id?: number;
    /**
     * 
     * @type {DeviceType}
     * @memberof HostDevice
     */
    type?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    topic?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    serial?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    deviceVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    partNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    timeServer?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    imei?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    firmwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    unlockTime?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    alertText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HostDevice
     */
    auxUnlockEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    auxUnlockText?: string;
    /**
     * 
     * @type {string}
     * @memberof HostDevice
     */
    auxUnlockTime?: string;
    /**
     * 
     * @type {number}
     * @memberof HostDevice
     */
    partnerId?: number;
    /**
     * 
     * @type {number}
     * @memberof HostDevice
     */
    resourceId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HostDevice
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HostDevice
     */
    online?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof HostDevice
     */
    installedOn?: Date;
    /**
     * 
     * @type {number}
     * @memberof HostDevice
     */
    boundCreditBalance?: number;
}

export function HostDeviceFromJSON(json: any): HostDevice {
    return HostDeviceFromJSONTyped(json, false);
}

export function HostDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostDevice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : DeviceTypeFromJSON(json['type']),
        'topic': !exists(json, 'topic') ? undefined : json['topic'],
        'serial': !exists(json, 'serial') ? undefined : json['serial'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'deviceVersion': !exists(json, 'device_version') ? undefined : json['device_version'],
        'partNumber': !exists(json, 'part_number') ? undefined : json['part_number'],
        'timeServer': !exists(json, 'time_server') ? undefined : json['time_server'],
        'timeZone': !exists(json, 'time_zone') ? undefined : json['time_zone'],
        'imei': !exists(json, 'imei') ? undefined : json['imei'],
        'firmwareVersion': !exists(json, 'firmware_version') ? undefined : json['firmware_version'],
        'unlockTime': !exists(json, 'unlock_time') ? undefined : json['unlock_time'],
        'alertText': !exists(json, 'alert_text') ? undefined : json['alert_text'],
        'auxUnlockEnabled': !exists(json, 'aux_unlock_enabled') ? undefined : json['aux_unlock_enabled'],
        'auxUnlockText': !exists(json, 'aux_unlock_text') ? undefined : json['aux_unlock_text'],
        'auxUnlockTime': !exists(json, 'aux_unlock_time') ? undefined : json['aux_unlock_time'],
        'partnerId': !exists(json, 'partner_id') ? undefined : json['partner_id'],
        'resourceId': !exists(json, 'resource_id') ? undefined : json['resource_id'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'online': !exists(json, 'online') ? undefined : json['online'],
        'installedOn': !exists(json, 'installed_on') ? undefined : (new Date(json['installed_on'])),
        'boundCreditBalance': !exists(json, 'bound_credit_balance') ? undefined : json['bound_credit_balance'],
    };
}

export function HostDeviceToJSON(value?: HostDevice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': DeviceTypeToJSON(value.type),
        'topic': value.topic,
        'serial': value.serial,
        'code': value.code,
        'device_version': value.deviceVersion,
        'part_number': value.partNumber,
        'time_server': value.timeServer,
        'time_zone': value.timeZone,
        'imei': value.imei,
        'firmware_version': value.firmwareVersion,
        'unlock_time': value.unlockTime,
        'alert_text': value.alertText,
        'aux_unlock_enabled': value.auxUnlockEnabled,
        'aux_unlock_text': value.auxUnlockText,
        'aux_unlock_time': value.auxUnlockTime,
        'partner_id': value.partnerId,
        'resource_id': value.resourceId,
        'active': value.active,
        'online': value.online,
        'installed_on': value.installedOn === undefined ? undefined : (value.installedOn.toISOString()),
        'bound_credit_balance': value.boundCreditBalance,
    };
}

